import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  TextField,
  MenuItem,
  Button,
  IconButton,
  Typography,
  Modal,
  Paper,
  Autocomplete,
  Icon,
} from "@mui/material";
import { CameraAlt, Image, Close, ArrowBack, Place } from "@mui/icons-material";
import axios from "axios";
import { API_URL } from "../api";
import { useDropzone } from "react-dropzone";
import "../css/FormAbsensi.css";
import { CustomModal } from "./CustomModal";

export default function FormForemanSection1({ onNext }) {
  const [formData, setFormData] = useState({
    user_id: "",
    nama_foreman: "",
    nama_supervisor: "",
    mine_permit_pengawas: "",
    lokasi: "",
    tempat: "",
    foto: null,
    fotoName: "",
    fotoPreview: "",
  });

  const [supervisorList, setSupervisorList] = useState([]);
  const [foremanList, setForemanList] = useState([]);
  const [searchQuery, setSearchQuery] = useState({
    foreman: "",
    supervisor: "",
  });
  const [filteredSupervisors, setFilteredSupervisors] = useState([]);
  const [filteredForemen, setFilteredForemen] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalConfig, setModalConfig] = useState({
    title: "",
    message: "",
    type: "info",
    buttons: [],
  });

  const showModal = (title, message, type = "info", buttons = []) => {
    setModalConfig({ title, message, type, buttons });
    setModalVisible(true);
  };
  const navigate = useNavigate();

  const { getRootProps, getInputProps } = useDropzone({
    accept: "image/*",
    onDrop: (acceptedFiles) => {
      if (acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        setFormData((prev) => ({
          ...prev,
          foto: file,
          fotoPreview: URL.createObjectURL(file),
          fotoName: file.name,
        }));
      }
    },
  });
  useEffect(() => {
    const fetchData = async () => {
      try {
        // 1. Ambil data pengguna dari kunci "user" yang benar
        const storedUser = localStorage.getItem("user");
        let userNik = "";
        if (storedUser) {
          // 2. Parse string JSON menjadi objek dan ambil NIK
          const userData = JSON.parse(storedUser);
          userNik = userData.nik || "";
        }
        const supervisorResponse = await axios.get(`${API_URL}/auth/pengawas`);

        setFormData((prev) => ({ ...prev, user_id: userNik }));
        setForemanList(supervisorResponse.data.data);
        setSupervisorList(supervisorResponse.data.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (searchQuery.foreman) {
      const filtered = foremanList.filter((foreman) =>
        foreman.nama.toLowerCase().includes(searchQuery.foreman.toLowerCase())
      );
      setFilteredForemen(filtered);
    } else {
      setFilteredForemen([]);
    }
  }, [searchQuery.foreman, foremanList]);

  useEffect(() => {
    if (searchQuery.supervisor) {
      const filtered = supervisorList.filter((supervisor) =>
        supervisor.nama
          .toLowerCase()
          .includes(searchQuery.supervisor.toLowerCase())
      );
      setFilteredSupervisors(filtered);
    } else {
      setFilteredSupervisors([]);
    }
  }, [searchQuery.supervisor, supervisorList]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSearchChange = (type) => (e) => {
    setSearchQuery((prev) => ({ ...prev, [type]: e.target.value }));
  };

  const handleSelectForeman = (foreman) => {
    if (foreman) {
      setFormData((prev) => ({
        ...prev,
        nama_foreman: foreman.nama,
        mine_permit_pengawas: foreman.mine_permit,
      }));
    }
  };

  const handleSelectSupervisor = (supervisor) => {
    if (supervisor) {
      setFormData((prev) => ({
        ...prev,
        nama_supervisor: supervisor.nama,
      }));
    }
  };

  const validateForm = () => {
    const errors = [];
    if (!formData.nama_foreman) errors.push("Nama Foreman");
    if (!formData.nama_supervisor) errors.push("Nama Supervisor");
    if (!formData.lokasi) errors.push("Tim");
    if (!formData.tempat) errors.push("Tempat");
    if (!formData.foto) errors.push("Foto");

    if (errors.length > 0) {
      showModal(
        "Data Belum Lengkap",
        `Harap lengkapi data berikut: ${errors.join(", ")}`,
        "warning"
      );
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      const fotoData =
        formData.foto instanceof File
          ? {
              file: formData.foto,
              preview: URL.createObjectURL(formData.foto),
              name: formData.foto.name,
            }
          : null;

      localStorage.setItem(
        "foremanForm1",
        JSON.stringify({
          ...formData,
          foto: fotoData,
        })
      );
      onNext();
    }
  };

  return (
    <div className="form-container">
      <header className="app-header">
        <div className="header-content">
          <button className="back-button" onClick={() => navigate(-1)}>
            <Icon>arrow_back</Icon>
          </button>
          <h1 className="header-title"> Absensi Hadir P5M</h1>
          <div className="header-spacer"></div>
        </div>
      </header>

      <Box sx={{ p: 3 }}>
        <Paper sx={{ p: 3, mb: 3 }}>
          <Autocomplete
            options={filteredForemen}
            getOptionLabel={(option) => option.nama}
            value={
              foremanList.find((f) => f.nama === formData.nama_foreman) || null
            }
            onChange={(e, newValue) => handleSelectForeman(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Cari Nama Foreman"
                fullWidth
                margin="normal"
                value={searchQuery.foreman}
                onChange={handleSearchChange("foreman")}
              />
            )}
          />

          <TextField
            label="No. Mine Permit Pengawas"
            fullWidth
            margin="normal"
            value={formData.mine_permit_pengawas}
            disabled
          />

          <Autocomplete
            options={filteredSupervisors}
            getOptionLabel={(option) => option.nama}
            value={
              supervisorList.find((s) => s.nama === formData.nama_supervisor) ||
              null
            }
            onChange={(e, newValue) => handleSelectSupervisor(newValue)}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Cari Nama Supervisor"
                fullWidth
                margin="normal"
                value={searchQuery.supervisor}
                onChange={handleSearchChange("supervisor")}
              />
            )}
          />

          <TextField
            select
            label="Tim"
            fullWidth
            margin="normal"
            value={formData.lokasi}
            onChange={handleChange}
            name="lokasi"
          >
            {[
              { label: "Pit Utara", value: "Pit Utara, KM 22" },
              { label: "Pit Selatan", value: "Pit Selatan, Office 33" },
              { label: "Tim Drone", value: "Drone, Head Office" },
            ].map((option) => (
              <MenuItem key={option.value} value={option.value}>
                {option.label}
              </MenuItem>
            ))}
          </TextField>

          <TextField
            label="Tempat"
            fullWidth
            margin="normal"
            value={formData.tempat}
            onChange={handleChange}
            name="tempat"
          />

          <Typography variant="body1" sx={{ mt: 2, mb: 1 }}>
            Masukan Foto:
          </Typography>

          {formData.foto ? (
            <Box sx={{ position: "relative", mb: 2 }}>
              <img
                src={formData.fotoPreview}
                alt="Preview"
                style={{ width: "100%", borderRadius: 4 }}
              />
              <IconButton
                onClick={() => setFormData((prev) => ({ ...prev, foto: null }))}
                sx={{
                  position: "absolute",
                  top: 8,
                  right: 8,
                  bgcolor: "rgba(255,255,255,0.7)",
                }}
              >
                <Close />
              </IconButton>
            </Box>
          ) : (
            <Box
              {...getRootProps()}
              sx={{
                border: "2px dashed #ccc",
                p: 4,
                textAlign: "center",
                cursor: "pointer",
                "&:hover": { borderColor: "primary.main" },
              }}
            >
              <input {...getInputProps()} />
              <CameraAlt fontSize="large" color="action" />
              <Typography>Seret foto kesini atau klik untuk memilih</Typography>
            </Box>
          )}
          {/* Modal */}
          <CustomModal
            visible={modalVisible}
            onClose={() => setModalVisible(false)}
            title={modalConfig.title}
            message={modalConfig.message}
            type={modalConfig.type}
            buttons={modalConfig.buttons}
          />
        </Paper>

        <Button
          variant="contained"
          fullWidth
          size="large"
          onClick={handleSubmit}
          disabled={
            !formData.nama_foreman ||
            !formData.nama_supervisor ||
            !formData.lokasi ||
            !formData.tempat ||
            !formData.foto
          }
        >
          Lanjut
        </Button>
      </Box>
    </div>
  );
}
